import { render, staticRenderFns } from "./footprints.vue?vue&type=template&id=6f54499e"
import script from "./footprints.vue?vue&type=script&lang=js"
export * from "./footprints.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports